<template>
    <div style="max-width: 400px; margin: 40px auto;">
      <select-input
        v-model="selected"
        :options="options"
        :multiple="true"
        :fetch-options="fetchOptions"
        :allow-create="false"
        placeholder="请输入敏感词"
        @search="handleSearch"
      >
        <template #item="{ item }">
          <span>{{ item.text }}</span>
        </template>
      </select-input>
      <div style="margin-top: 24px; color: #888; font-size: 14px;">
        已选敏感词：<span v-for="item in selected" :key="item" style="margin-right: 8px; color: #1890ff;">{{ item }}</span>
      </div>
    </div>
  </template>

  <script>
  import SelectInput from '../SelectInput.vue';
  export default {
    components: { SelectInput },
    data() {
      return {
        selected: [],
        options: [
          { text: '代持', value: '代持' },
          { text: '转卖', value: '转卖' },
          { text: '转售', value: '转售' },
        ],
      };
    },
    methods: {
      fetchOptions(keyword) {
        // 模拟异步搜索敏感词
        return new Promise((resolve) => {
          setTimeout(() => {
            const all = [
              { text: '代持1', value: '代持1' },
              { text: '代持2', value: '代持2' },
              { text: '代持3', value: '代持3' },
              { text: '代持4', value: '代持4' },
              { text: '代持5', value: '代持5' },
              { text: '代持', value: '代持' },
              { text: '转卖', value: '转卖' },
            ];
            resolve(all.filter(item => !keyword || item.text.includes(keyword)));
          }, 300);
        });
      },
      handleSearch(keyword) {
        console.log(keyword);
      },
    },
  };
  </script>
